import { MPInstancesHub } from "@/api/RequestAxios/RequestAxiosHub";
import { MPInstanceAuthX360 } from "@/api/RequestAxios/RequestAxiosAuthX360";
import type * as Types from "./profile.types";
import config from "@/config";
import { unpackProfileEmailData } from "../user/user.mapper";
import type { IServerUserEmailData } from "../user/user.types";

const userProfileUrl = () => `/user_profile`;

const updateLastManagedUrl = () => `/profile/last_managed`;
const emailVerificationUrl = () => `/email_verified`;
const requestVerificationUrl = () =>
  `/send_verification_email?app_name=${config.appName}`;

export const updateLastManaged = async (channelId: string) => {
  const { data } = await MPInstancesHub.buffedInstances.newCrm.patch(
    updateLastManagedUrl(),
    {
      channel_id: channelId,
    }
  );

  return data;
};

export const getUserProfile = async () => {
  const { data } =
    await MPInstanceAuthX360.buffedInstances.get<Types.IServerResponseClientInfo>(
      userProfileUrl()
    );

  return data;
};

export const getEmailVerification = async () => {
  const { data } =
    await MPInstanceAuthX360.buffedInstances.get<IServerUserEmailData>(
      emailVerificationUrl()
    );

  return unpackProfileEmailData(data);
};

export const requestVerificationEmail = async () => {
  const { data } = await MPInstanceAuthX360.buffedInstances.post<{
    email_verified: boolean;
    email?: string;
  }>(requestVerificationUrl());

  return data;
};
